import DateFormat from "../../pages/DateFormat";
import { useTranslation } from "react-i18next";

export default function ProjectDatesTab(prop) {
  const data = prop.data;
  const { t } = useTranslation();

  return (
    <>
     <div id="content" class="dashboard-wrap campaign-section">
      <div className="listing-content">
        <div className="project-information">
          <h6>{t("finance.project_dates")}</h6>
          <div className="translation-summary">
            <div className="project-table">
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.bid_out_started_date")}</div>
                  <div className="text"><DateFormat date={data?.bidOutStartDate} /></div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.bid_due_date")}</div>
                  <div className="text"><DateFormat date={data?.bidDueDate} /></div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.bid_selection_deadline")}</div>
                  <div className="text"><DateFormat date={data?.bidSelectDeadlineDate} /></div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.bid_selected_date")}</div>
                  <div className="text"><DateFormat date={data?.translationStartDate} /></div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.project_delivery_date")}</div>
                  <div className="text"><DateFormat date={data?.requestedDate} /></div>
                </li>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.project_closed_date")}</div>
                  <div className="text"><DateFormat date={data?.closeDate} /></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}
